// @todo: Migrate to 'Slider' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Slider} from '@wandb/weave/components';
import {debounce} from 'lodash';
import React, {useState} from 'react';

export const SettingSlider = ({
  dataTest,
  name,
  min,
  max,
  step,
  sliderValue,
  updateSetting,
}: {
  dataTest?: string;
  name: string;
  min: number;
  max: number;
  step: number;
  sliderValue: number;
  updateSetting: (newVal: number) => void;
}) => {
  const [currValue, setCurrValue] = useState(sliderValue);
  const debouncedUpdateSetting = debounce(updateSetting, 300);

  return (
    <div className="flex w-full items-center gap-8" data-test={dataTest}>
      <div className="flex-1">
        <Slider.Root
          name={name}
          min={min}
          max={max}
          step={step}
          orientation="horizontal"
          onValueChange={([newVal]) => {
            // If use is dragging slider, don't update config continuosly
            setCurrValue(newVal);
          }}
          onValueCommit={([newVal]) => {
            // Once user lets go of slider, we'll update config
            debouncedUpdateSetting(newVal);
          }}
          value={[currValue]}>
          <Slider.Track>
            <Slider.Range className="grow" />
          </Slider.Track>
          <Slider.Thumb />
        </Slider.Root>
      </div>
      <Slider.Display
        isDirty={true}
        min={min}
        max={max}
        step={step}
        value={currValue}
        onChange={setCurrValue}
        onBlur={newVal => {
          const clampedVal = Math.max(min, Math.min(newVal, max));
          setCurrValue(clampedVal);
          updateSetting(clampedVal);
        }}
      />
    </div>
  );
};
